/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simplified_ChineseInputs */

const en_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simplified Chinese`)
};

const fr_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chinois simplifié`)
};

const de_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinfachtes Chinesisch`)
};

const it_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cinese semplificato`)
};

const ru_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упрощенный китайский`)
};

const es_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chino simplificado`)
};

const zh_cn2_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简体中文`)
};

const ja_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`簡体字中国語`)
};

const hi_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सरलीकृत चीनी`)
};

const pt_pt2_simplified_chinese = /** @type {(inputs: Simplified_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chinês simplificado`)
};

/**
* | output |
* | --- |
* | "Simplified Chinese" |
*
* @param {Simplified_ChineseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const simplified_chinese = /** @type {((inputs?: Simplified_ChineseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simplified_ChineseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_simplified_chinese(inputs)
	if (locale === "de") return de_simplified_chinese(inputs)
	if (locale === "it") return it_simplified_chinese(inputs)
	if (locale === "ru") return ru_simplified_chinese(inputs)
	if (locale === "es") return es_simplified_chinese(inputs)
	if (locale === "zh-CN") return zh_cn2_simplified_chinese(inputs)
	if (locale === "ja") return ja_simplified_chinese(inputs)
	if (locale === "hi") return hi_simplified_chinese(inputs)
	if (locale === "pt-PT") return pt_pt2_simplified_chinese(inputs)
	return en_simplified_chinese(inputs)
});